module.exports = __webpack_public_path__ + "assets/RetinaNarr-MediumItalic.db4c50aa057962ee47d97aed485f5e68.woff";